export default __webpack_public_path__ + "static/media/garouscreen.6b99ec73.png";